let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2UCLo")).then(() => parcelRequire('b8Vr3'));